import { Outlet } from 'react-router-dom';
import './BookingLayout.css';

// Public, unauthenticated shell for the client booking app — styled to match
// the Get It Done landing site (getitdone.getit-media.com.au).
export default function BookingLayout() {
  return (
    <div className="booking-layout">
      <header className="booking-topbar">
        <a className="booking-brand" href="https://getitdone.getit-media.com.au" target="_blank" rel="noopener noreferrer">
          <img src="/GetItDone-Logo-White.svg" alt="Get It Done — Efficient Home Solutions" className="booking-logo" />
        </a>
        <a className="booking-phone" href="tel:+61404012394">📞 0404 012 394</a>
      </header>
      <main className="booking-main">
        <Outlet />
      </main>
      <footer className="booking-footer">
        <p><strong>Get It Done</strong> — Efficient Home Solutions</p>
        <p>
          <a href="https://getitdone.getit-media.com.au" target="_blank" rel="noopener noreferrer">getitdone.getit-media.com.au</a>
          {' '}· <a href="tel:+61404012394">0404 012 394</a> · Hope Island, Helensvale &amp; the northern Gold Coast
        </p>
        {/* The Facebook page, @getitdonegc (backlog #761, GID-Session-023) */}
        <p><a href="https://www.facebook.com/getitdonegc" target="_blank" rel="noopener noreferrer">📘 Follow us on Facebook</a></p>
      </footer>
    </div>
  );
}
